const Modal = {
  namespaced: true,
  state: () => ({
    modalCount: 0,
    modals: {
      modalModel: {
        eventId: 'hier staat het eventId',
        title: 'Dit is een dummy titel',
        content: 'Hier staat een heel verhaal wat niet klopt',
        show: true,
        type: 'notification|okcancel|autonotification',
      },
      modalList: [],
    },
  }),
  mutations: {
    closeModal(state, modalId) {
      const index = state.modals.modalList.findIndex((modal) => {
        return modal.id == modalId;
      });
      if (index !== -1) state.modals.modalList.splice(index, 1);
    },
  },

  getters: {
    getModalList: (state) => {
      return state.modals.modalList;
    },
  },
  actions: {
    setModal({ state }, { title, text, type, param, eventName = '' }) {
      //type == 'notification', 'okcancel', 'autonotification'
      let modal = Object.assign({}, state.modals.modalModel);
      modal.content = text;
      modal.title = title;
      modal.eventName = eventName;
      modal.type = type;
      modal.id = state.modalCount++;
      modal.param = param;
      if (
        !state.modals.modalList.find(
          (existingModal) => existingModal.eventName === eventName
        )
      ) {
        state.modals.modalList.push(modal);
      }
    },
  },
};

export default Modal;
